export enum EventCategory {
  Onboarding = "Onboarding",
  Target = "Target",
  Baseline = "Baseline",
  Dashboard = "Dashboard",
  Plan = "Plan",
  LeadGen = "LeadGen",
  Feedback = "Feedback",
  NavigationMenu = "NavigationMenu",
  Email = "Email",
  FAQ = "FAQ",
  GuidedTour = "GuidedTour",
}
